<ng-container *ngIf="state$ | async as state">
  <button
    *ngIf="state?.v?.isPrevAvailable"
    mat-button
    class="ib-btn-primary ib-btn-outline ib-btn-lg"
    [disabled]="isRegistrLoading$ | async"
    (click)="setPrevStep()"
  >
    <span class="flex items-center"
      ><i class="material-icons">chevron_left</i><span>Prev</span></span
    >
  </button>

  <div *ngIf="state?.v?.isFirstStep || state?.v?.isLastStep">&nbsp;</div>

  <ib-btn-wrap
    *ngIf="state?.v?.isNextAvailable"
    [isLoading]="
      (isNextLoading$ | async) && state?.v?.activeStepObj?.form?.valid
    "
  >
    <!-- [disabled]="state?.v?.isNextBtnDisabled || (isNextLoading$ | async)" -->
    <button
      mat-button
      class="ib-btn-primary ib-btn-lg relative"
      [disabled]="state?.v?.isNextBtnDisabled || (isNextLoading$ | async)"
      (click)="setNextStep()"
    >
      <span class="flex items-center"
        ><span>Next</span><i class="material-icons">chevron_right</i></span
      >
    </button>
  </ib-btn-wrap>

  <ib-btn-wrap
    *ngIf="state?.v?.isFinishAvailable"
    [isLoading]="isRegistrLoading$ | async"
  >
    <button
      [disabled]="state?.v?.isFinishDisabled || (isRegistrLoading$ | async)"
      mat-button
      class="ib-btn-primary ib-btn-lg relative"
      (click)="finish()"
    >
      Finish
    </button>
  </ib-btn-wrap>
</ng-container>
